import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";

export default function LegalLayout({ seo, eyebrow, title, updated, children }) {
  return (
    <>
      <Seo {...seo} />
      <section className="bg-[#07111F] text-white relative overflow-hidden">
        <div className="xa-blob" style={{ width: 420, height: 420, background: "#6D4DFF", top: -160, left: -100, opacity: 0.4 }} />
        <div className="absolute inset-0 xa-grid-dark opacity-50 pointer-events-none" />
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-20 relative">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#00D4FF]">{eyebrow}</div>
          <h1 className="font-display mt-5 text-4xl lg:text-5xl font-bold tracking-tight">{title}</h1>
          {updated && <div className="mt-4 font-mono text-xs text-white/45">Last updated · {updated}</div>}
        </div>
      </section>
      <section className="bg-[#F7F9FC] border-b border-[#E5E7EB]">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16 prose-legal">
          <div className="space-y-8 text-[#07111F] leading-relaxed">
            {children}
          </div>
          <div className="mt-12 pt-8 border-t border-[#E5E7EB] text-sm text-[#6B7280]">
            Questions? Reach us at <a href={"mail" + "to:" + "contact" + "@" + "xadentra.com"} className="text-[#6D4DFF] underline">{"contact" + "@" + "xadentra.com"}</a>{" "}
            or visit our <Link to="/contact" className="text-[#6D4DFF] underline">contact page</Link>.
          </div>
        </div>
      </section>
    </>
  );
}

export function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-2xl font-semibold text-[#07111F] mb-3">{title}</h2>
      <div className="space-y-3 text-[#475569]">{children}</div>
    </div>
  );
}
